/**
 * TestRepositoryPage - Test Repository with Modern Layout
 *
 * Sub-tabs (Heat Profile, Test Repository, DCAL Generator), then list card and table.
 * No duplicate page title / back link above the tabs (content is described in the list card).
 */

import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Flame, FileText, Wrench } from 'lucide-react';
import TechnicalPageAgGrid from '../../components/CRCE Technical/TechnicalPageAgGrid';
import './HeatProfilePage.css';
import './TestRepositoryPage.css';

const TECHNICAL_TAB_ITEMS = [
    { id: 'heat-profile', label: 'Heat Profile', path: '/heat-profile', icon: <Flame size={18} /> },
    { id: 'test-repository', label: 'Test Repository', path: '/TechnicalPage', icon: <FileText size={18} /> },
    { id: 'dcal-generator', label: 'DCAL Generator', path: '/DCALGenerator', icon: <Wrench size={18} /> },
];

const TestRepositoryPage = () => {
    const history = useHistory();
    const location = useLocation();
    const currentPath = location.pathname;

    const handleTabClick = (path) => {
        if (path !== currentPath) {
            history.push(path);
        }
    };

    return (
        <div className="test-repository-page heat-profile-page">
            <div className="heat-profile-tabs-container">
                <div className="heat-profile-tabs">
                    {TECHNICAL_TAB_ITEMS.map((item) => (
                        <div
                            key={item.id}
                            className={`heat-profile-tab-item ${currentPath === item.path ? 'active' : ''}`}
                            onClick={() => handleTabClick(item.path)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handleTabClick(item.path);
                                }
                            }}
                            role="tab"
                            tabIndex={0}
                            aria-selected={currentPath === item.path}
                        >
                            {item.icon}
                            {item.label}
                        </div>
                    ))}
                </div>
            </div>



            <div className="test-repository-content-wrapper heat-profile-content-wrapper">
                <TechnicalPageAgGrid embeddedInModernLayout />
            </div>
        </div>
    );
};

export default TestRepositoryPage;
